export type PermissionEntry = {
  permission: string;
  displayName: string;
  workflowType: string | null;
  workflowTypeDisplayName: string | null;
};

export type CurrentPermissions = {
  userId: string;
  userDisplayName: string;
  userEmail: string;
  permissions: PermissionEntry[];
  adGroups: string[];
  canViewAllWorkflows: boolean;
  canCreateWorkflowTypes: (string | number)[];
  canDeleteAnyWorkflow: boolean;
  canManagePermissions: boolean;
  testingOverrideEnabled: boolean;
};

export type LoggedInUser = {
  userId: string;
  userDisplayName: string;
  userEmail: string;
};

export type EffectiveUser = CurrentPermissions;

export type CurrentUser = EffectiveUser;

export enum Permission {
  ViewAllWorkflows = 'ViewAllWorkflows',
  DeleteAnyWorkflow = 'DeleteAnyWorkflow',
  EditAnyWorkflow = 'EditAnyWorkflow',
  EditAnyWorkflows = 'EditAnyWorkflows',
  ManagePermissions = 'ManagePermissions',
  CreateUKPaymentApproval = 'CreateUKPaymentApproval',
  CreateDubaiPaymentApproval = 'CreateDubaiPaymentApproval',
  CreateDubaiTransferRequisition = 'CreateDubaiTransferRequisition',
  CreateDubaiPaymentFromOfficeAccount = 'CreateDubaiPaymentFromOfficeAcc',
  CreateOvertimeApproval = 'CreateOvertimeApproval',
  CreateGiftHospitalityDonationUk = 'CreateGiftHospitalityDonationUk',
  CreateGiftHospitalityDonationDubai = 'CreateGiftHospitalityDonationDubai',
  CreateGiftHospitalityDonationDublin = 'CreateGiftHospitalityDonationDublin',
  // PLOP_INJECT_CREATE_PERMISSION
  EditOwnWorkflows = 'EditOwnWorkflows',
  DeleteOwnWorkflows = 'DeleteOwnWorkflows',
  Spoof = 'Spoof',
  Reassign = 'Reassign',
}
